import React, { FunctionComponent } from 'react'
import styles from './NavItem.module.sass'
import { NavLink } from 'react-router-dom'
import clsx from 'clsx'
import Badge from '../../etc/Badge/Badge'

interface Props {
    text: string,
    route: string,
    className?: string;
    icon: FunctionComponent,
    badge?: {
        text?: string | number,
        title?: string,
        color?: string,
    },
    outside?: boolean,
    exact?: boolean,
    coloring?: 'fill' | 'stroke',
}

const NavItem: FunctionComponent<Props> = props => <Badge {...props.badge} padding={15}>
    <NavLink
        className={clsx(styles.navItem, props.className)}
        to={props.route}
        exact={props.exact}
        activeClassName={styles.active}
    >
        <props.icon/>
        <span className={styles.text}>{props.text}</span>
    </NavLink>
</Badge>

export default NavItem